import React, { useEffect } from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
// Routes
import { loginpage, notfoundpage, redirectPage } from '../routes'

import { connect } from 'react-redux';
import { login } from '../store/actions/authenAction';

import { IntlProvider } from 'react-intl';
import AuthorizeCallbackPage from "../screens/authentication/oauth/AuthorizeCallbackPage";
import AuthorizeSimLoginPage from "../screens/authentication/oauth/AuthorizeSimLoginPage";
import KUSuperAppOAuthCallbackPage from "../screens/authentication/oauth/KUSuperAppOAuthCallbackPage";

import useIsAuthenticate from "./hooks/useIsAuthenticate";
import PassAuthenToVerifyPage from "../screens/authentication/verify/PassAuthenToVerifyPage";
import { useAuth } from "./hooks/useAuth";
import AuthenticationAdmin from '../screens/authentication/authenticationAdmin/AuthenticationAdmin';
import DownloadCsvPage from '../screens/assessment/DownloadCsvPage';


const NewRouter = (props) => {

    const { isAuthenticated } = useIsAuthenticate(props)
    const { logout } = useAuth()

    useEffect(() => {
        const removeLoadingClass = () => {
            document.documentElement.classList.remove('app-loading')
        }
        const splashScreen = document.querySelector('.app-splash-screen')
        if (splashScreen) {
            splashScreen.style.opacity = 0
            setTimeout(() => {
                splashScreen && splashScreen.parentNode.removeChild(splashScreen)
                removeLoadingClass()
            }, 300)
        } else {
            removeLoadingClass()
        }
    }, []);


    const setTitle = (title) => {
        // document.title = titleTemplate.replace('%s', title)
        document.title = 'My KU';
    }

    const getLoginIntent = () => {
        let pathName = props.location.pathname
        const except = [
            process.env.REACT_APP_LOGIN_ROUTE
        ]
        let search = ""
        if (!except.includes(pathName)) {
            search = "?intent=" + pathName
        }
        return search
    }

    console.log("login : new router", props)

    return (
        <IntlProvider
            locale={props.locale}
            messages={props.messages}
        >
            <Switch>
                {!isAuthenticated &&
                    <Route
                        path={process.env.REACT_APP_LOGIN_ROUTE}
                        exact
                        render={props => {
                            return <loginpage.layout {...props}>
                                <loginpage.component {...props} setTitle={setTitle}
                                    scrollTop={scrollTop} />
                            </loginpage.layout>
                        }}
                    />
                }

                {isAuthenticated &&
                    <Route
                        path="/redirect"
                        exact
                        render={props => {
                            return <redirectPage.layout {...props}>
                                <redirectPage.component {...props} />
                            </redirectPage.layout>
                        }}
                    />}

                <Route path='/oauth/authorize-callback'>
                    <AuthorizeCallbackPage />
                </Route>

                {/*<Route path='/oauth/logout'>*/}
                {/*    <AuthorizeLogoutPage />*/}
                {/*</Route>*/}

                <Route path='/oauth/sim-login'>
                    <AuthorizeSimLoginPage />
                </Route>

                <Route path='/kusuperapp/oauth-callback/alllogin'>
                    <KUSuperAppOAuthCallbackPage />
                </Route>

                <Route
                    path="/404"
                    exact
                    render={props => {
                        return <notfoundpage.layout {...props}>
                            <notfoundpage.component {...props} setTitle={setTitle}
                                scrollTop={scrollTop} />
                        </notfoundpage.layout>
                    }}
                />

                <Route
                    path={"/logout"}
                    exact
                    render={props => {
                        logout()
                        return <></>
                    }}
                />

                <Route path="/verify/authen-to-verify">
                    <PassAuthenToVerifyPage />
                </Route>

                <Route path="/login-admin/aJBLVb9ILF">
                    <AuthenticationAdmin />
                </Route>

                <Route path="/asm/downloadCsv">
                    <DownloadCsvPage />
                </Route>

                <Route exact
                    path='*'>
                    <Redirect
                        to={isAuthenticated ? {
                            pathname: "/redirect"
                        } : {
                            pathname: process.env.REACT_APP_LOGIN_ROUTE,
                            search: getLoginIntent()
                        }}
                    />
                </Route>

            </Switch>
        </IntlProvider>
    )

}

export default withRouter(connect(store => {
    return {
        locale: store.theme.locale,
        messages: store.theme.messages,
        routeList: store.routes.routeList
    }
}, { login })(NewRouter))

const scrollTop = (
    to,
    duration,
    element = document.scrollingElement || document.documentElement
) => {
    if (element.scrollTop === to) return
    const start = element.scrollTop
    const change = to - start
    const startDate = +new Date()

    if (!duration) {
        element.scrollTop = to
        return
    }

    // t = current time; b = start value; c = change in value; d = duration
    const easeInOutQuad = (t, b, c, d) => {
        t /= d / 2
        if (t < 1) return c / 2 * t * t + b
        t--
        return -c / 2 * (t * (t - 2) - 1) + b
    }

    const animateScroll = () => {
        const currentDate = +new Date()
        const currentTime = currentDate - startDate
        element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration))
        if (currentTime < duration) {
            requestAnimationFrame(animateScroll)
        } else {
            element.scrollTop = to
        }
    }

    animateScroll()
}
